var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 6,
    fill: "#ED3241"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9212 8.13746C19.1521 8.33951 19.1755 8.69049 18.9734 8.9214L11.1957 17.8103C11.0944 17.926 10.9497 17.9946 10.796 17.9997C10.6424 18.0048 10.4934 17.946 10.3847 17.8373L7.05139 14.5039C6.83443 14.287 6.83443 13.9352 7.05139 13.7183C7.26835 13.5013 7.62011 13.5013 7.83706 13.7183L10.7505 16.6317L18.1372 8.18973C18.3393 7.95882 18.6903 7.93542 18.9212 8.13746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCheck);
export default __webpack_public_path__ + "static/media/ic_check.e20839f9aba5ceaaceee196cf14b2f9f.svg";
export { ForwardRef as ReactComponent };